import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '..\\layouts\\error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_metaplugin_cca5d4ee from 'nuxt_plugin_metaplugin_cca5d4ee' // Source: .\\pwa\\meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_c3568a06 from 'nuxt_plugin_iconplugin_c3568a06' // Source: .\\pwa\\icon.plugin.js (mode: 'all')
import nuxt_plugin_nuxtleaflet_0554d7f8 from 'nuxt_plugin_nuxtleaflet_0554d7f8' // Source: .\\nuxt-leaflet.js (mode: 'client')
import nuxt_plugin_portalvue_d4773774 from 'nuxt_plugin_portalvue_d4773774' // Source: .\\portal-vue.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_7ed07c56 from 'nuxt_plugin_cookieuniversalnuxt_7ed07c56' // Source: .\\cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_nuxtuseragent_d8941a94 from 'nuxt_plugin_nuxtuseragent_d8941a94' // Source: .\\nuxt-user-agent.js (mode: 'all')
import nuxt_plugin_nuxtsvgsprite_0db0630b from 'nuxt_plugin_nuxtsvgsprite_0db0630b' // Source: .\\nuxt-svg-sprite.js (mode: 'all')
import nuxt_plugin_axios_850bc7a6 from 'nuxt_plugin_axios_850bc7a6' // Source: .\\axios.js (mode: 'all')
import nuxt_plugin_gtm_53be0a43 from 'nuxt_plugin_gtm_53be0a43' // Source: .\\gtm.js (mode: 'all')
import nuxt_plugin_axiosbase_a5d2790e from 'nuxt_plugin_axiosbase_a5d2790e' // Source: ..\\plugins\\axios-base.js (mode: 'all')
import nuxt_plugin_axiostimeout_5b92ee23 from 'nuxt_plugin_axiostimeout_5b92ee23' // Source: ..\\plugins\\axios-timeout.js (mode: 'all')
import nuxt_plugin_repositories_a519ad4e from 'nuxt_plugin_repositories_a519ad4e' // Source: ..\\plugins\\repositories.js (mode: 'all')
import nuxt_plugin_kontainerassets_493d181a from 'nuxt_plugin_kontainerassets_493d181a' // Source: ..\\plugins\\kontainer-assets.js (mode: 'all')
import nuxt_plugin_lazysizesclient_60ea0274 from 'nuxt_plugin_lazysizesclient_60ea0274' // Source: ..\\plugins\\lazysizes.client.js (mode: 'client')
import nuxt_plugin_vuei18n_5a00aec8 from 'nuxt_plugin_vuei18n_5a00aec8' // Source: ..\\plugins\\vue-i18n.js (mode: 'all')
import nuxt_plugin_globalhelpers_393add06 from 'nuxt_plugin_globalhelpers_393add06' // Source: ..\\plugins\\global-helpers.js (mode: 'all')
import nuxt_plugin_mediahelpers_7efe435e from 'nuxt_plugin_mediahelpers_7efe435e' // Source: ..\\plugins\\media-helpers.js (mode: 'all')
import nuxt_plugin_bodyscrolllockclient_497b1654 from 'nuxt_plugin_bodyscrolllockclient_497b1654' // Source: ..\\plugins\\body-scroll-lock.client.js (mode: 'client')
import nuxt_plugin_veevalidate_1a0c1998 from 'nuxt_plugin_veevalidate_1a0c1998' // Source: ..\\plugins\\vee-validate.js (mode: 'all')
import nuxt_plugin_globalfilters_7552a3d0 from 'nuxt_plugin_globalfilters_7552a3d0' // Source: ..\\plugins\\global-filters.js (mode: 'all')
import nuxt_plugin_axiosauth_cb3e2d7c from 'nuxt_plugin_axiosauth_cb3e2d7c' // Source: ..\\plugins\\axios-auth.js (mode: 'all')
import nuxt_plugin_vuemq_7319a416 from 'nuxt_plugin_vuemq_7319a416' // Source: ..\\plugins\\vue-mq.js (mode: 'all')
import nuxt_plugin_visitoridclient_3f5a00ae from 'nuxt_plugin_visitoridclient_3f5a00ae' // Source: ..\\plugins\\visitor-id.client.js (mode: 'client')
import nuxt_plugin_klaviyoactiveonsiteclient_30c413a6 from 'nuxt_plugin_klaviyoactiveonsiteclient_30c413a6' // Source: ..\\plugins\\klaviyo-active-on-site.client.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"F_headless-baseline","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"}],"script":[{"src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Fcore-js\u002F2.6.12\u002Fcore.min.js","defer":true},{"src":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002Fintl\u002F1.2.5\u002FIntl.min.js","defer":true},{"type":"text\u002Fjavascript","src":"https:\u002F\u002Fconsent.cookiebot.com\u002Fuc.js","id":"Cookiebot","data-cbid":"045b591f-ec43-4e93-a146-21efd1b550f2","async":true},{"type":"text\u002Fjavascript","src":"https:\u002F\u002Ffiles.userlink.ai\u002Fpublic\u002Fembed.min.js","charset":"utf-8","id":"bai-scr-emb","data-cid":"6735bffcce668005f76d9842","domain":"bronnum.dk","async":true},{"type":"text\u002Fjavascript","src":"\u002Fscripts\u002Fsleeknote.js","id":"sleeknoteScript","async":true},{"type":"text\u002Fjavascript","src":"\u002Fscripts\u002Flead-info.js","id":"LeadInfo","async":true},{"type":"text\u002Fjavascript","src":"\u002Fscripts\u002Fvgo.js","id":"VisitorGlobalObjectAlias","body":true,"async":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-KX28GW9')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"link":[{"rel":"preload","href":"\u002Ffonts\u002Fnunito-sans-extrabold.woff","crossorigin":"anonymous","as":"font","type":"font\u002Fwoff"},{"rel":"preload","href":"\u002Ffonts\u002Fnunito-sans-extralight.woff","crossorigin":"anonymous","as":"font","type":"font\u002Fwoff"},{"rel":"preload","href":"\u002Ffonts\u002Fnunito-sans-v6-latin-regular.woff","crossorigin":"anonymous","as":"font","type":"font\u002Fwoff"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-KX28GW9&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_metaplugin_cca5d4ee === 'function') {
    await nuxt_plugin_metaplugin_cca5d4ee(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_c3568a06 === 'function') {
    await nuxt_plugin_iconplugin_c3568a06(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtleaflet_0554d7f8 === 'function') {
    await nuxt_plugin_nuxtleaflet_0554d7f8(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_d4773774 === 'function') {
    await nuxt_plugin_portalvue_d4773774(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_7ed07c56 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_7ed07c56(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtuseragent_d8941a94 === 'function') {
    await nuxt_plugin_nuxtuseragent_d8941a94(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsvgsprite_0db0630b === 'function') {
    await nuxt_plugin_nuxtsvgsprite_0db0630b(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_850bc7a6 === 'function') {
    await nuxt_plugin_axios_850bc7a6(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_53be0a43 === 'function') {
    await nuxt_plugin_gtm_53be0a43(app.context, inject)
  }

  if (typeof nuxt_plugin_axiosbase_a5d2790e === 'function') {
    await nuxt_plugin_axiosbase_a5d2790e(app.context, inject)
  }

  if (typeof nuxt_plugin_axiostimeout_5b92ee23 === 'function') {
    await nuxt_plugin_axiostimeout_5b92ee23(app.context, inject)
  }

  if (typeof nuxt_plugin_repositories_a519ad4e === 'function') {
    await nuxt_plugin_repositories_a519ad4e(app.context, inject)
  }

  if (typeof nuxt_plugin_kontainerassets_493d181a === 'function') {
    await nuxt_plugin_kontainerassets_493d181a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazysizesclient_60ea0274 === 'function') {
    await nuxt_plugin_lazysizesclient_60ea0274(app.context, inject)
  }

  if (typeof nuxt_plugin_vuei18n_5a00aec8 === 'function') {
    await nuxt_plugin_vuei18n_5a00aec8(app.context, inject)
  }

  if (typeof nuxt_plugin_globalhelpers_393add06 === 'function') {
    await nuxt_plugin_globalhelpers_393add06(app.context, inject)
  }

  if (typeof nuxt_plugin_mediahelpers_7efe435e === 'function') {
    await nuxt_plugin_mediahelpers_7efe435e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bodyscrolllockclient_497b1654 === 'function') {
    await nuxt_plugin_bodyscrolllockclient_497b1654(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_1a0c1998 === 'function') {
    await nuxt_plugin_veevalidate_1a0c1998(app.context, inject)
  }

  if (typeof nuxt_plugin_globalfilters_7552a3d0 === 'function') {
    await nuxt_plugin_globalfilters_7552a3d0(app.context, inject)
  }

  if (typeof nuxt_plugin_axiosauth_cb3e2d7c === 'function') {
    await nuxt_plugin_axiosauth_cb3e2d7c(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemq_7319a416 === 'function') {
    await nuxt_plugin_vuemq_7319a416(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_visitoridclient_3f5a00ae === 'function') {
    await nuxt_plugin_visitoridclient_3f5a00ae(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_klaviyoactiveonsiteclient_30c413a6 === 'function') {
    await nuxt_plugin_klaviyoactiveonsiteclient_30c413a6(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
